import type PersonalDetails from '../../../contracts/PersonalDetails';
import type { PurchasesResponse } from '../../../contracts/Purchase';
import type UserProfileData from '../../../contracts/UserProfileData';
import * as types from './types';

export const fetchPurchasesBegin = () => ({
  type: types.FETCH_PURCHASES_BEGIN
});

export const fetchPurchasesSuccess = (payload: PurchasesResponse) => ({
  type: types.FETCH_PURCHASES_SUCCESS,
  payload
});

export const fetchPurchasesFailure = (error: unknown) => ({
  type: types.FETCH_PURCHASES_FAILURE,
  payload: error
});

export const fetchPersonalDetailsBegin = () => ({
  type: types.FETCH_PERSONAL_DETAILS_BEGIN
});

export const fetchPersonalDetailsSuccess = (payload: PersonalDetails) => ({
  type: types.FETCH_PERSONAL_DETAILS_SUCCESS,
  payload
});

export const fetchPersonalDetailsFailure = (error: unknown) => ({
  type: types.FETCH_PERSONAL_DETAILS_FAILURE,
  payload: error
});

export const fetchPersonalDetailsDismissError = () => ({
  type: types.FETCH_PERSONAL_DETAILS_DISMISS_ERROR
});

export const updatePersonalInformationBegin = () => ({
  type: types.UPDATE_PERSONAL_INFORMATION_BEGIN
});

export const updatePersonalInformationSuccess = (payload: unknown) => ({
  type: types.UPDATE_PERSONAL_INFORMATION_SUCCESS,
  payload
});

export const updatePersonalInformationFailure = (error: unknown) => ({
  type: types.UPDATE_PERSONAL_INFORMATION_FAILURE,
  payload: error
});

export const updateContactsDetailsBegin = () => ({
  type: types.UPDATE_CONTACTS_DETAILS_BEGIN
});

export const updateContactsDetailsSuccess = () => ({
  type: types.UPDATE_CONTACTS_DETAILS_SUCCESS
});

export const updateContactsDetailsFailure = (error: unknown) => ({
  type: types.UPDATE_CONTACTS_DETAILS_FAILURE,
  payload: error
});

export const updateAddressBegin = () => ({
  type: types.UPDATE_ADDRESS_BEGIN
});

export const updateAddressSuccess = () => ({
  type: types.UPDATE_ADDRESS_SUCCESS
});

export const updateAddressFailure = () => ({
  type: types.UPDATE_ADDRESS_FAILURE
});

export const fetchUserProfileDataBegin = () => ({
  type: types.FETCH_USER_PROFILE_DATA_BEGIN
});

export const fetchUserProfileDataSuccess = (payload: UserProfileData) => ({
  type: types.FETCH_USER_PROFILE_DATA_SUCCESS,
  payload
});

export const fetchUserProfileDataFailure = (error: unknown) => ({
  type: types.FETCH_USER_PROFILE_DATA_FAILURE,
  payload: error
});

export const updateUserProfileDataBegin = () => ({
  type: types.UPDATE_USER_PROFILE_DATA_BEGIN
});

export const updateUserProfileDataSuccess = (payload: unknown) => ({
  type: types.UPDATE_USER_PROFILE_DATA_SUCCESS,
  payload
});

export const updateUserProfileDataFailure = (error: unknown) => ({
  type: types.UPDATE_USER_PROFILE_DATA_FAILURE,
  payload: error
});
